import Vue from 'vue'
import axios from '../plugins/axios'

const api = {
  todos: {
    list (params) {
      return axios.get('/api/todos', {
        params
      })
    },
    create (params) {
      return axios.post('/api/todos', params)
    },
    read (params) {
      return axios.get(`/api/todos/${params.id}`, {
        params
      })
    },
    update (params) {
      return axios.put(`/api/todos/${params.id}`, params)
    },
    delete (params) {
      return axios.delete(`/api/todos/${params.id}`, {
        params
      })
    }
  }
}

Vue.api = api
Vue.prototype.$api = api

export default api
